<div [class]="isStandalonePage ? 'min-h-full bg-[#fafaf7] font-sans' : ''">
  <div [class]="isStandalonePage ? 'max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-6' : ''">

    @if (isStandalonePage) {
      <div class="flex items-center justify-between">
        <div>
          <h1 class="page-title">{{ pageTitle }}</h1>
          <p class="text-xs text-stone-400 mt-0.5">Gestion des documents</p>
        </div>
      </div>
    }

<!-- Page selector (embedded mode only) -->
@if (!pageCode) {
  <div class="mb-4">
    <select class="border border-stone-200 text-sm rounded-xl px-3 py-2 text-stone-700 bg-white outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100"
      [value]="selectedPageCode()" (change)="selectedPageCode.set($any($event.target).value); loadDocuments()">
      <option value="">-- Choisir une page --</option>
      @for (code of pageCodes(); track code) {
        <option [value]="code">{{ code }}</option>
      }
    </select>
  </div>
}

@if (errorMessage()) {
  <div class="p-3 rounded-xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-2 mb-4">
    <span class="material-icons text-base text-red-500">error_outline</span>
    {{ errorMessage() }}
  </div>
}

@if (isLoading()) {
  <div class="flex items-center justify-center py-10">
    <div class="relative w-8 h-8">
      <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
      <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
    </div>
  </div>
}

@if (!isLoading()) {
  <div class="bg-white rounded-2xl border border-stone-100 overflow-hidden">
    <!-- Table header -->
    <div class="px-5 py-3 border-b border-stone-100 flex items-center justify-between">
      <p class="text-xs text-stone-400">{{ documents().length }} document{{ documents().length > 1 ? 's' : '' }}</p>
      <button (click)="openAddForm()"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-xs font-medium">
        <span class="material-icons text-sm">add</span>
        Ajouter
      </button>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="border-b border-stone-100 bg-stone-50">
            <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider">Titre</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider">Ordre</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider">Fichier</th>
            <th class="px-4 py-3 text-right text-xs font-medium text-stone-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-stone-50">
          @if (documents().length === 0) {
            <tr>
              <td colspan="4" class="px-6 py-12 text-center">
                <div class="flex flex-col items-center gap-2">
                  <span class="material-icons text-3xl text-stone-200">description</span>
                  <p class="text-stone-400 text-sm">Aucun document</p>
                </div>
              </td>
            </tr>
          }
          @for (doc of documents(); track doc.public_document_id) {
            <tr class="hover:bg-stone-50 transition-colors">
              <td class="px-4 py-3">
                <p class="font-medium text-stone-800 text-xs">{{ doc.public_document_first_title }}</p>
              </td>
              <td class="px-4 py-3">
                <span class="text-xs text-stone-400 font-mono">{{ doc.public_document_display_order }}</span>
              </td>
              <td class="px-4 py-3">
                @if (doc.file_url) {
                  <a [href]="doc.file_url" target="_blank"
                    class="inline-flex items-center gap-1 text-xs text-primary-600 hover:text-primary-800 font-medium">
                    <span class="material-icons text-sm">download</span>
                    {{ doc.file_extension?.toUpperCase() || 'PDF' }}
                  </a>
                } @else {
                  <span class="text-xs text-stone-300">Pas de fichier</span>
                }
              </td>
              <td class="px-4 py-3">
                <div class="flex items-center justify-end gap-1">
                  <button (click)="openEditForm(doc)" title="Modifier"
                    class="w-7 h-7 rounded-lg flex items-center justify-center text-stone-400 hover:bg-primary-50 hover:text-primary-600 transition-all">
                    <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z" />
                    </svg>
                  </button>
                  <button (click)="confirmDelete(doc.public_document_id)" title="Supprimer"
                    class="w-7 h-7 rounded-lg flex items-center justify-center text-stone-400 hover:bg-red-50 hover:text-red-500 transition-all">
                    <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}

<!-- Add / Edit modal -->
@if (showForm()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-md mx-4">
      <div class="flex items-center justify-between mb-5">
        <h3 class="text-base font-semibold text-stone-800">
          {{ editingDocument() ? 'Modifier le document' : 'Ajouter un document' }}
        </h3>
        <button (click)="closeForm()" class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-400 hover:bg-stone-100 transition-all">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      @if (errorMessage()) {
        <div class="p-3 rounded-xl bg-red-50 border border-red-100 text-xs text-red-700 mb-4">{{ errorMessage() }}</div>
      }

      <div class="space-y-4">
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Titre <span class="text-red-500">*</span></label>
          <input type="text" [value]="formData().title"
            (input)="updateField('title', $any($event.target).value)"
            placeholder="Titre du document"
            class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 placeholder-stone-400 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all" />
        </div>
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Ordre d'affichage</label>
          <input type="number" [value]="formData().order" min="1"
            (input)="updateField('order', +$any($event.target).value)"
            class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all" />
        </div>
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Fichier</label>
          @if (editingDocument()?.file_url && !selectedFile()) {
            <div class="flex items-center gap-2 p-2.5 rounded-xl border border-stone-200 bg-stone-50 mb-2">
              <span class="material-icons text-sm text-stone-400">attach_file</span>
              <span class="text-xs text-stone-600 flex-1 truncate">{{ editingDocument()?.file_name || 'Fichier actuel' }}</span>
              <a [href]="editingDocument().file_url" target="_blank" class="text-xs text-primary-600 hover:text-primary-800 font-medium flex-shrink-0">Voir</a>
            </div>
          }
          <label class="flex items-center gap-3 w-full border border-dashed border-stone-300 rounded-xl px-3 py-3 cursor-pointer hover:border-primary-300 hover:bg-primary-50 transition-all">
            <span class="material-icons text-stone-400 text-lg">upload_file</span>
            <span class="text-xs text-stone-500">
              @if (selectedFile()) {
                <span class="text-primary-600 font-medium">{{ selectedFile()!.name }}</span>
              } @else {
                {{ editingDocument()?.file_url ? 'Remplacer le fichier (optionnel)' : 'Choisir un fichier (optionnel)' }}
              }
            </span>
            <input type="file" class="hidden" (change)="onFileChange($event)" accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx" />
          </label>
        </div>
      </div>

      <div class="flex items-center justify-end gap-2 mt-6">
        <button type="button" (click)="closeForm()" [disabled]="isSaving()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 disabled:opacity-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving()"
          class="inline-flex items-center gap-2 px-5 py-2 bg-primary-600 text-white rounded-xl hover:bg-primary-700 disabled:opacity-50 transition-colors text-sm font-semibold">
          @if (isSaving()) {
            <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          } @else {
            <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
          }
          {{ isSaving() ? 'Enregistrement…' : (editingDocument() ? 'Modifier' : 'Ajouter') }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Confirm delete modal -->
@if (pendingDelete()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-2xl bg-red-50 flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
          </svg>
        </div>
        <div>
          <p class="font-semibold text-stone-800 text-sm">Confirmer la suppression</p>
          <p class="text-xs text-stone-500 mt-0.5">Ce document sera supprimé du site public.</p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelDelete()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="applyDelete()"
          class="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-xl transition-colors">
          Supprimer
        </button>
      </div>
    </div>
  </div>
}

  </div>
</div>
